module.exports = __webpack_public_path__ + "img/check-true.8708850d.svg";